import {WorkEmailValidationRules} from 'mkt-ssr/generated/validation/workEmailValidationRules';

export interface WorkEmailValidationOptions {
  countryCode?: string;
}

/**
 * Check if work email validation should be applied for a given country code
 */
export function shouldValidateWorkEmail(
  countryCode: string | undefined,
): boolean {
  if (!countryCode) {
    return false;
  }
  return WorkEmailValidationRules.validatedCountries.has(countryCode);
}

/**
 * Check if an email address contains a personal email domain
 */
export function containsPersonalDomain(emailAddress: string): boolean {
  const email = (emailAddress || '').toLowerCase().replace(/\s/g, '');
  return Array.from(WorkEmailValidationRules.disallowedDomains).some(
    (domain) => {
      return email.includes(domain);
    },
  );
}

/**
 * Validate if an email is a work email (not a personal email domain)
 * Returns true if the email is valid (work email) or validation should not be applied
 * Returns false if the email is invalid (personal email domain in a validated country)
 */
export function isWorkEmail(
  emailAddress: string,
  options: WorkEmailValidationOptions = {},
): boolean {
  const {countryCode} = options;

  // If country doesn't require validation, always return true
  if (!shouldValidateWorkEmail(countryCode)) {
    return true;
  }

  // Check if email contains a personal domain
  return !containsPersonalDomain(emailAddress);
}
